import {
  z,
  uploadedFileBaseSchema,
  uploadStatusSchema,
  createUploadedFilesSchema,
  createFileUploadValidator,
} from '@tasama/utils';

export const chatInputUploadedFileSchema = uploadedFileBaseSchema;
export const ChatInputUploadStatusEnum = uploadStatusSchema;

export const getChatInputUploadSchema = (t: (_key: string) => string) =>
  z.object({
    uploadedFiles: createUploadedFilesSchema({
      maxBytes: 5 * 1024 * 1024,
      allowedExts: ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx', 'txt'],
      minFiles: 0,
      requireComplete: true,
      messages: {
        required: t('supportTickets.validation.required'),
        mustComplete: t('supportTickets.validation.mustComplete'),
        tooLarge: t('supportTickets.validation.tooLarge'),
        invalidType: t('supportTickets.validation.invalidType'),
      },
    }),
  });

export const chatInputUploadSchema = getChatInputUploadSchema((key) => key);

export type ChatInputUploadFormData = z.infer<typeof chatInputUploadSchema>;
export type ChatInputUploadedFile = z.infer<typeof chatInputUploadedFileSchema>;

export const chatInputUploadDefaultValues: ChatInputUploadFormData = {
  uploadedFiles: [],
};

export const getValidateChatInputUploadForm = (t: (_key: string) => string) =>
  createFileUploadValidator(getChatInputUploadSchema(t));

export const validateChatInputUploadForm = createFileUploadValidator(
  chatInputUploadSchema
);
